import Routes from './Routes';
import { ToastContainer } from 'react-toastify';
import { HelmetProvider } from 'react-helmet-async';
import { CartProvider } from './contexts/CartContext';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <HelmetProvider>
      <CartProvider>
        <ToastContainer position="top-right" autoClose={3000} />
        <Routes />
      </CartProvider>
    </HelmetProvider>
  );
}

export default App;
